$(document).ready(function () {
    var carouselSlider = $("#owl-produit");
    // on regarde si le slider existe
    if (carouselSlider.length >= 1) {
        carouselSlider.owlCarousel({
            nav: true,
            navText: ['<i class="icon-arrow-left"></i>', '<i class="icon-arrow-right"></i>'],
            slideSpeed: 300,
            dots: true,
            dotsSpeed: 400,
            singleItem: true,
            items: 1
        });

        makeDotImage();
    }
});

/**
 * Cette methode permet d'ajouter les images à la place des dots dans owl carousel
 */
function makeDotImage() {
    $('.owl-stage').children().each(function(i) {
        let imagePath = $(this).find('img').attr('src')
        // on ne recupère pas les items qui n'ont pas d'image
        if (imagePath === undefined) {
            return;
        }
        let elementDot = $('#owl-produit').find('.owl-dots').children()[i];
        let htmlImg = `<img alt="" src="${imagePath}" width="100px" heigth="100px">`;
        $(elementDot).html(htmlImg);
    });
}